<script>
import Vue from 'vue';
import EntityService from '@/services/entityService.js';
import LinhaDeListaDeDados from "./LinhaDeListaDeDados.vue";

export default {
    name: 'TabelaDeListaDeDados',
    components: {
        LinhaDeListaDeDados
    },
    props: [
        "usuarioStore",
        "controlesDesativados",
        "visualizandoDado",
        "editandoDado",
        "criandoDado"
    ],
    emits: [
        "update:alteraControlesDesativados",
        "update:alteraDado",
        "update:alteraVisualizandoDado",
        "update:alteraEditandoDado",
        "update:alteraCriandoDado"
    ],
    data() {
        return {
            dados: [],
            loadingListaDeDados: false,
            loadedDados: false,
            dadosHeaders: [
                { text: "",                value: "visualizar"},
                { text: "",                value: "actions"},
                { text: "Número",          value: "sequential"},
                { text: "Título",          value: "descriptionDes"},
                { text: "Status",          value: "status"},
                { text: "Cliente",         value: "numeroCliente"},
                { text: "Formato",         value: "fomatDocument"},
            ],
            deletandoDado: false,
            dadoADeletar: null,
            entityService: new EntityService('DesenhoNumber'),
            pagination: {
                page: 1,
                limit: 30,
                pages: 1,
            },
        };
    },
    computed: {
        temPermissaoDelete() {
            if (!this.usuarioStore) return false;
            const modules = this.usuarioStore?.modules || [];
            const module = modules.find(m => m.title === 'DesenhoNumber');
            return module && module.permissions && module.permissions.includes('Excluir');
        },
        temPermissaoCriar() {
            if (!this.usuarioStore) return false;
            const modules = this.usuarioStore?.modules || [];
            const module = modules.find(m => m.title === 'DesenhoNumber');
            return module && module.permissions && module.permissions.includes('Criar');
        }
    },
    methods: {
        alteraControlesDesativados(update) {
            this.$emit('update:alteraControlesDesativados', update);
        },
        alteraDado(update) {
            this.$emit('update:alteraDado', update);
        },
        alteraVisualizandoDado(update) {
            this.$emit('update:alteraVisualizandoDado', update);
        },
        alteraEditandoDado(update) {
            this.$emit('update:alteraEditandoDado', update);
        },
        alteraCriandoDado(update) {
            this.$emit('update:alteraCriandoDado', update);
        },
        abrirFormularioCriar() {
            this.alteraCriandoDado({ criandoDado: true, dado: {} });
        },
        async loadDados() {
            this.loadingListaDeDados = true;
            this.loadedDados = false;

            try {
                console.log('🔄 Iniciando carregamento dos desenhos...');
                console.log('📄 Página:', this.pagination.page, '| Limite:', this.pagination.limit);
                const response = await this.entityService.getAll(
                    this.pagination.page,
                    this.pagination.limit
                );
                
                console.log('✅ Resposta completa:', response);
                console.log('📦 response.data:', response.data);
                console.log('📦 response.data.data:', response.data?.data);
                console.log('📦 É array?', Array.isArray(response.data?.data));
                console.log('📦 Tamanho do array:', response.data?.data?.length);
                
                let dadosCarregados = response.data?.data || response.data || [];
                
                console.log('✅ Dados extraídos:', dadosCarregados.length, 'desenhos');
                console.log('✅ Tipo de dadosCarregados:', typeof dadosCarregados, Array.isArray(dadosCarregados));
                
                if (dadosCarregados.length > 0) {
                    console.log('📋 Primeiro desenho:', dadosCarregados[0]);
                }
                
                // Usar Vue.set para garantir reatividade
                Vue.set(this, 'dados', dadosCarregados);
                
                console.log('✅ this.dados após Vue.set:', this.dados.length);
                console.log('✅ this.dados:', this.dados);
                
                // Atualizar total de páginas
                if (response.data?.pages) {
                    this.pagination.pages = response.data.pages;
                } else if (response.data?.data?.pages) {
                    this.pagination.pages = response.data.data.pages;
                }
                console.log('📄 Total de páginas:', this.pagination.pages);
                
                this.loadedDados = true;
            } catch (error) {
                console.error("❌ Erro ao carregar desenhos:", error);
                Vue.set(this, 'dados', []);
                this.loadedDados = true;
            } finally {
                this.loadingListaDeDados = false;
            }
        },
        confirmarDelecao(dado) {
            this.dadoADeletar = dado;
            this.deletandoDado = true;
        },
        async deletarDado() {
            if (!this.dadoADeletar) return;
            
            try {
                this.deletandoDado = false;
                await this.entityService.delete(this.dadoADeletar.id || this.dadoADeletar.code);
                await this.loadDados();
            } catch (error) {
                console.error("❌ Erro ao deletar desenho:", error);
                alert("Erro ao deletar desenho");
            }
        },
        async changePage() {
            await this.loadDados();
            window.scrollTo(0, 0);
        }
    },
    mounted() {
        console.log('🚀 Componente montado - iniciando loadDados()');
        this.loadDados();
    }
};
</script>

<template>
    <div>
        <v-card class="c-dados">

            <v-card-title class="c-dados__header">

            <h3 class="c-header__titulo">
                Numeração de Desenho
            </h3>

            <div class="c-header__usuario-botao">
                <v-btn
                    v-if="temPermissaoCriar"
                    class="c-header__botao-novo"
                    color="success"
                    dark
                    @click="abrirFormularioCriar"
                    :disabled="controlesDesativados"
                >
                    <v-icon left>mdi-plus</v-icon>
                    Novo
                </v-btn>
            </div>
            
        </v-card-title>

        <div class="c-table-wrapper">

            <div class="c-table">

                <div class="c-table__headers">
                    <div class="c-table__header" v-for="dadoHeader in dadosHeaders"
                        :key="dadoHeader.value"
                    >
                        <div class="c-table__header-content">
                            {{dadoHeader.text}}
                        </div>
                    </div>
                </div>

                <div class="c-table__body">

                    <div v-if="loadingListaDeDados" class="c-carregando">
                        <v-progress-circular indeterminate></v-progress-circular>
                        <span>Carregando dados...</span>
                    </div>

                    <div v-else-if="!loadedDados" class="c-carregando">
                        <span>Processando...</span>
                    </div>

                    <div v-else-if="dados.length === 0" class="c-vazio">
                        <p>Nenhum desenho encontrado</p>
                    </div>

                    <LinhaDeListaDeDados
                        v-for="dado in dados"
                        v-else
                        :key="dado.code || dado.id"
                        :dado="dado"
                        :usuarioStore="usuarioStore"
                        :controlesDesativados="controlesDesativados"
                        :temPermissaoDelete="temPermissaoDelete"
                        @update:alteraDado="alteraDado"
                        @update:alteraVisualizandoDado="alteraVisualizandoDado"
                        @update:alteraEditandoDado="alteraEditandoDado"
                        @delete="confirmarDelecao"
                    ></LinhaDeListaDeDados>

                </div>

            </div>

        </div>

        <!-- Dialog de confirmação de deleção -->
        <v-dialog v-model="deletandoDado" max-width="400">
            <v-card>
                <v-card-title>Confirmar Deleção</v-card-title>
                <v-card-text>
                    Tem certeza que deseja deletar o desenho <strong>{{ dadoADeletar?.sequential || dadoADeletar?.code }}</strong>?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="deletandoDado = false">Cancelar</v-btn>
                    <v-btn color="error" text @click="deletarDado">Deletar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-card>

    <!-- Paginação -->
    <div class="text-center mt-4">
        <v-pagination
            @input="changePage"
            v-model="pagination.page"
            :length="pagination.pages"
            :total-visible="10"
        ></v-pagination>
    </div>

    </div>
</template>

<style scoped>

.c-dados__header {
    display: grid; 
    grid-template-columns: 1fr auto; 
    grid-gap: 10px;
    align-items: center;
    padding: 20px !important;
}

.c-header__titulo {
    font-size: 24px;
    font-weight: 500;
}

.c-header__usuario-botao {
    display: flex;
    grid-gap: 10px;
    align-items: center;
}

.c-table-wrapper {
    overflow: auto;
    max-height: calc(100vh - 250px);
}

.c-table {
    display: grid;
    grid-template-columns: 120px 120px repeat(5, 1fr);
    grid-auto-rows: min-content;
    min-width: 1000px;
}

.c-table__headers {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    background-color: #f5f5f5;
    border-bottom: 2px solid #ddd;
    position: sticky;
    top: 0;
    z-index: 10;
}

.c-table__header {
    padding: 15px 10px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
}

.c-table__header-content {
    display: flex;
    align-items: center;
}

.c-table__body {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

.c-carregando, .c-vazio {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    gap: 15px;
    color: #666;
}

</style>
